const staffOption = {
    title: {
        text: '',
        subtext: '',
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            crossStyle: {
                color: '#999'
            }
        }
    },
    xAxis: [
        {
            type: 'category',
            data: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            axisPointer: {
                type: 'shadow'
            },
        }
    ],
    yAxis: [
        {
            type: 'value',
            min: 0,
            max: 32,
            interval: 50,
            axisLabel: {
                formatter: '{value} 人'
            }
        },
        {
            type: 'value',
            min: 0,
            max: 25,
            interval: 5,
            axisLabel: {
                formatter: '{value} %'
            }
        }
    ],
    series: [
        {
            name: '',
            type: 'bar',
            barWidth: '30px',
            tooltip: {
                valueFormatter: function (value) {
                    return value + '人';
                }
            },
            data: [
                18, 9, 27, 14, 13, 17, 13, 22, 32, 20, 14, 21
            ]
        },
        {
            name: '',
            type: 'bar',
            barWidth: '30px',
            tooltip: {
                valueFormatter: function (value) {
                    return value + '人';
                }
            },
            data: [
                16, 9, 20, 4, 7, 7, 6, 2, 4, 1, 6, 12
            ]
        },
        {
            name: '增长率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
                valueFormatter: function (value) {
                    return value + '%';
                }
            },
            data: [5, 4, 13, 2.3, 6.3, 10.2, 8.3, 3.4, 16.5, 3.0, 12.0, 6.2]
        }
    ],
    grid: {
        x: 50,
        x2: 60,
        y: 50,
        y2: 30
    },
}


const incomeBar = {
    xAxis: [
        {
            type: 'category',
            data: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            axisPointer: {
                type: 'shadow'
            }
        }
    ],
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    yAxis: [
        {
            type: 'value',
            axisLabel: {
                formatter: '{value}'
            }
        }
    ],
    series: [
        {
            type: 'bar',
            tooltip: {},
            data: [
                821, 694, 827, 514, 913, 617, 413, 822, 532, 720, 714, 921
            ]
        }
    ],
}

const degreeOption = {
    title: {
        text: '人员结构',
        subtext: '',
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        top: 40,
        orient: 'vertical',
        left: 'left'
    },
    series: [
        {
            type: 'pie',
            radius: ['40%', '70%'],
            data: [
                {value: 73, name: '硕士研究生'},
                {value: 48, name: '博士研究生'},
                {value: 58, name: '博士后'},
                {value: 30, name: '其他'},
                {value: 104, name: '本科'},
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ],
}

var treeOption = {
    tooltip: {
        trigger: 'item',
        triggerOn: 'mousemove'
    },
    series: [
        {
            type: 'tree',
            top: '1%',
            left: '7%',
            bottom: '5%',
            right: '20%',
            symbolSize: 14,
            label: {
                position: 'left',
                verticalAlign: 'middle',
                align: 'right',
                fontSize: 14
            },
            leaves: {
                label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left'
                }
            },
            emphasis: {
                focus: 'descendant'
            },
            expandAndCollapse: true,
            animationDuration: 550,
            animationDurationUpdate: 750
        }
    ]
};


const dataCount = {
    title: {
        text: '数据概览',
        subtext: '单位（亿条）',
        left: 'center'
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        orient: 'vertical',
        left: 'left'
    },
    series: [
        {
            name: '单位（亿条）',
            type: 'pie',
            radius: ['40%', '70%'],
            data: [
                {value: 3.27, name: '企业工商数据'},
                {value: 5.52, name: '高收入人群'},
                {value: 2.21, name: '企业高管'},
                {value: 0.48, name: '知识产权'},
                {value: 1.40, name: '判决文书'}
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};


let chartSetting = {
    getStaffOption() {
        return staffOption;
    },
    getIncomeBar() {
        return incomeBar;
    },
    getDegreeOption() {
        return degreeOption
    },
    getDataCount() {
        return dataCount
    },
    getTreeOption() {
        return treeOption
    },
}
export default {
    chartSetting
}



// WEBPACK FOOTER //
// ./src/api/chartData.js